import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { SiteRenderer } from "../components/sites/SiteRenderer";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PublicForm from "./PublicForm";

const pathSlug = () => window.location.pathname.replace(/^\/+|\/+$/g, "").split("/")[0];

export default function HostSite() {
  if (window.location.pathname.startsWith("/f/")) return <BrowserRouter><Routes><Route path="/f/:id" element={<PublicForm />} /></Routes></BrowserRouter>;
  return <HostPages />;
}

function HostPages() {
  const [site, setSite] = useState(undefined);
  const [slug, setSlug] = useState(pathSlug());
  useEffect(() => { api.get("/public/sites-by-host", { params: { host: window.location.hostname } }).then((r) => setSite(r.data)).catch(() => setSite(null)); }, []);
  useEffect(() => {
    const onPop = () => setSlug(pathSlug());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
  const cur = site ? (site.pages.find((p) => p.slug === slug) || site.pages[0]) : null;
  useEffect(() => {
    if (!site || !cur) return;
    document.title = cur.seo_title || `${cur.title} | ${site.name}`;
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
    m.content = cur.seo_desc || "";
    window.scrollTo(0, 0);
  }, [site, cur]);
  const go = (s) => { const home = s === site.pages[0].slug; window.history.pushState({}, "", home ? "/" : `/${s}`); setSlug(home ? "" : s); };
  if (site === undefined) return <div className="grid min-h-screen place-items-center bg-white text-sm text-slate-500">Loading…</div>;
  if (!site) return <div className="grid min-h-screen place-items-center bg-white text-slate-600" data-testid="host-site-not-found">This website isn't available.</div>;
  return <div className="min-h-screen" data-testid="host-site"><SiteRenderer site={site} pageSlug={cur.slug} linkBase="" onNavigate={go} /></div>;
}
